module.exports = __webpack_public_path__ + "img/rail-signal.76b9a141.png";